export default __webpack_public_path__ + "static/media/avatar19-mujer.0a2c9dbf.png";